<template>
  <div>
    <PageTitle :route="$route"> </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <CostMaterialTransportationForm
          v-if="costMaterialTransportation"
          :costMaterialTransportation="costMaterialTransportation"
        />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import CostMaterialTransportationForm from "@/components/reports/costmaterialtransportation/CostMaterialTransportationForm.vue";

export default {
  name: "CostMaterialTransportationEdit",
  components: {
    PageTitle,
    PageRowWrapper,
    CostMaterialTransportationForm,
  },
  computed: {
    ...mapState({
      costMaterialTransportation: (state) =>
        state.costmaterialtransportation.costMaterialTransportation,
    }),
  },
  methods: {
    ...mapActions("costmaterialtransportation", ["fetchById"]),
  },

  mounted() {
    this.fetchById(this.$route.params.id);
  },
};
</script>
